<template>
  <div @click="handleClick"
       @keyup.enter="handleClick"
       aria-label="Image thumbnail">
    <div :class="classListInner">
      <div
        data-background
        :class="classListWrapper"
        :style="{ 'transform': selected ? 'scale(.75)' : 'scale(1)', 'background-color': color }"
      >
        <LazyImage
          v-if="image"
          :image="image"
          @error="handleError"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LazyImage from '@vuedir/components/LazyImage'

/**
 * Image.vue
 */
export default {
  components: {
    LazyImage,
  },

  props: {
    // eslint-disable-next-line vue/require-prop-types
    image: {
      default: null,
    },

    color: {
      type: String,
      default: 'white'
    },

    selected: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click', 'error'],

  data () {
    return {
    }
  },

  computed: {
    classListInner () {
      return [
        'pt-full relative flex-none',
        this.disabled ? 'bg-gray-200 cursor-not-allowed' : 'bg-gray-50 cursor-pointer',
      ]
    },

    classListWrapper () {
      return [
        'absolute inset-0 flex items-center justify-center overflow-hidden transition-all',
      ]
    },
  },

  methods: {
    handleClick () {
      if (!this.disabled) {
        this.$emit('click')
      }
    },

    handleError () {
      this.$emit('error')
    },
  },
}
</script>
